<template>
	<div>
		<layout-1
			:table_name="'Contracts'"
			:id=pageid
			:searchbar=false
			:searchbardate=true
			:custombuttons="[8,9,10]"
			:navbar=true
			:nav_items="['Add Contract']"
			:nav_item_perms="['83']"
			:button_perm="'83'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0319'"
			:select_reroute=false
			v-on:selectCustom="selectCustom"
			v-on:select="select"
			style="width:100%; height:calc(100vh - 50px);"
		></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.CONTRACTS_PAGE,
		}
	},
	methods: {
		selectCustom(col,index,search_term){
			if(index==8) index=1;
			else if(index==9) index=2;
			else if(index==10) index=3;

			router.push('/0320?q='+col[0]+';'+index+';'+search_term);
		},
		select(col,search_term){
			var index=4;

			router.push('/0320?q='+col[0]+';'+index+';'+search_term);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Contracts.vue